// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1GIrw","header":"styles_header__2RsKy","status":"styles_status__1AJfz","title":"styles_title__mm7Nh","actions":"styles_actions__qbuNy"};